import React, { useRef, useContext, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormDialog } from 'components/dialogs/formDialog';
import { TranslationFieldOptions, getValidationPairsForTranslatableText, getValidationShapeForTranslatableText } from 'utils/schemaHelper';
import { TranslatableInput } from 'components/formInputs/tranlatableInput';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Config } from 'configs';

export const ProductCustomTagAddEditForm = ({
  itemData,
  isOpen,
  closeModal,
  tagIndex,
  onSaved,
  productId,
  allTags,
}) => {
  const { editById } = useContext(CompanyContext);
  const { state: auth } = useContext(AuthContext);

  const schema = yup.object().shape({
    tag: yup
      .object()
      .shape(
        getValidationShapeForTranslatableText(
          itemData?.tag,
          TranslationFieldOptions.REQUIRE_AT_LEAST_ONE,
        ),
        getValidationPairsForTranslatableText(),
      ),
  });

  const cancelButtonRef = useRef(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: schema.default(),
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset(itemData);
  }, [itemData, reset]);

  const onFormSubmit = async (data) => {
    const submitedData = { ...data };

    const currentTags = allTags || [];

    if (itemData && tagIndex >= 0) {
      currentTags[tagIndex] = submitedData;
    } else {
      currentTags.push(submitedData);
    }

    const updateClause = { $set: { tags: currentTags } };

    await editById(
      {
        collectionName: Config.DATA.COLLECTIONS.PRODUCTS,
        id: productId,
        updateClause,
        token: auth.token,
        resourceV2: 'AdminProduct',
        updateTypeV2: 'Tags',
        updateDataV2: updateClause.$set,
        companyIdForV2: auth.company?.company,
      },
      () => {
        onSaved(currentTags);
      },
    );
  };

  const onError = (data) => console.log(data);

  return (
    <FormDialog
      isOpen={isOpen}
      cancelButtonRef={cancelButtonRef}
      onClose={closeModal}
      title={itemData ? 'Edit' : 'Add New'}
      buttons={[
        { text: 'Save', type: 'submit', color: 'red' },
        { text: 'Cancel', onClick: closeModal, color: 'gray' },
      ]}
      onSubmit={handleSubmit(onFormSubmit, onError)}
      small
    >
      <div className="grid grid-cols-6 gap-6 text-left">
        <div className="col-span-6">
          <TranslatableInput
            name="tag"
            register={register}
            error={errors?.tag}
            containerClassName="sm:col-span-3"
            labelClassName="block text-sm font-medium text-gray-700"
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="Tag*"
          />
        </div>
      </div>
    </FormDialog>
  );
};
